export default __webpack_public_path__ + "static/AssetLibraries-74b06d4fe6e09e3dc98b561af613a4cf.png";